<template>
    <div class="bo-dropdown">
        <div
            @click="toggleDropdown"
            class="dropdown-menu-label"
        >
            {{ dropdownTitle ? dropdownTitle : "Select an option" }}
            <i class="icon-expandmore"></i>
        </div>
        <div
            v-if="isOpen"
            class="dropdown-menu-container"
        >
            <div
                v-for="option in options"
                :key="option.id"
                class="dropdown-menu-item"
                @click="selectOption(option)"
            >
                <slot name="menu-item"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        dropdownTitle: {
            type: String,
            default: null,
        },
        options: {
            type: [Array, Object],
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            isOpen: false,
        };
    },
    methods: {
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        selectOption(option) {
            this.isOpen = false;
        },
    },
};
</script>
